"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDesignSystem = void 0;

const createDesignSystem = obj => {
  let parent = "";

  const iterate = obj => {
    Object.keys(obj).forEach((key, index) => {
      //console.log(`parent: ${parent}, key: ${key}, value: ${obj[key]}`)
      if (typeof obj[key] !== "object") {
        document.getElementById('root').style.setProperty("--".concat(parent, "_").concat(key), obj[key]);
      }

      if (typeof obj[key] === 'object' && obj[key] !== null) {
        parent = key;
        iterate(obj[key]);
      }
    });
  };

  iterate(obj);
};

exports.createDesignSystem = createDesignSystem;